/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    removeInfo: {
        id: 'quoteandbind.PPRLinedirectives.templates.Remove Condominium Details',
        defaultMessage: 'Remove Condominium Details',
    },
    removeInfoDesc: {
        id: 'quoteandbind.PPRLinedirectives.templates.Condominium Details',
        defaultMessage: 'Are you sure you want to remove this Condominium Details from the list?',
    },
    occupancy: {
        id: 'quoteandbind.PPRLinedirectives.templates.Occupancy : ',
        defaultMessage: 'Occupancy : ',
    }
});